import { EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { ActiveLookup, LookupKeys, Messages } from '@ag-common-lib/public-api';
import { Observable } from 'rxjs';
import { LookupsService } from '../../services';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

/**
 * @deprecated Use TShirtSizesDropdown instead
 */
@Component({
  selector: 'ag-shr-t-short-size-select-box',
  templateUrl: './t-short-size-select-box.component.html',
  styleUrls: ['./t-short-size-select-box.component.scss'],
})
export class TShortSizeSelectBoxComponent {
  @HostBinding('class') className = 't-short-size-select-box';
  @Input() readOnly: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() name: string;
  @Input() validationGroup: string;
  @Input() disabled: boolean = false;
  @Input() label: string = 'T-Shirt Size';
  @Input() placeholder: string = '';
  @Input() labelMode: 'static' | 'floating' | 'hidden' = 'floating';
  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  @Output() selectedItemChange = new EventEmitter();

  public LookupKeys = LookupKeys;
  public BaseModelKeys = BaseModelKeys;
  public tShortSizesLookup$: Observable<ActiveLookup[]>;
  protected readonly requiredText = Messages.REQUIRED_TEXT;

  constructor(private readonly lookupsService: LookupsService) {
    this.tShortSizesLookup$ = this.lookupsService.tShortSizesLookup$;
  }
}
